var map = {
	"./da/main2.yml": 67,
	"./de/main2.yml": 68,
	"./en/main2.yml": 69,
	"./es/main2.yml": 70,
	"./fr/main2.yml": 71,
	"./gd/main2.yml": 72,
	"./id/main2.yml": 73,
	"./it/main2.yml": 74,
	"./ru/main2.yml": 75,
	"./si/main2.yml": 76,
	"./tr/main2.yml": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;